module.exports = __webpack_public_path__ + "img/pr-4.ab5d7fdc.png";